"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    DATA_POSITIONING_ESCAPED: function() {
        return DATA_POSITIONING_ESCAPED;
    },
    DATA_POSITIONING_HIDDEN: function() {
        return DATA_POSITIONING_HIDDEN;
    },
    DATA_POSITIONING_INTERSECTING: function() {
        return DATA_POSITIONING_INTERSECTING;
    },
    DATA_POSITIONING_PLACEMENT: function() {
        return DATA_POSITIONING_PLACEMENT;
    },
    POSITIONING_END_EVENT: function() {
        return POSITIONING_END_EVENT;
    }
});
const DATA_POSITIONING_INTERSECTING = 'data-popper-is-intersecting';
const DATA_POSITIONING_ESCAPED = 'data-popper-escaped';
const DATA_POSITIONING_HIDDEN = 'data-popper-reference-hidden';
const DATA_POSITIONING_PLACEMENT = 'data-popper-placement';
const POSITIONING_END_EVENT = 'fui-positioningend';
